import { ComponentProps } from "react";
import { cardActionsClasses } from "./CardActions.style";

export type CardActionsProps = ComponentProps<"div">;

const CardActions = (props: CardActionsProps) => {
  const { className, ...rest } = props;
  return <div {...rest} className={cardActionsClasses({ class: className })} />;
};

export default CardActions;
